<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8 wrap>
      <v-layout column wrap main-section>
        <v-flex xs12 pt-3>
          <v-card-title>
            <v-icon>mdi-cart-outline</v-icon>
            <h4 class="headline halfwhite-text ml-2">Buy Ovations</h4>
          </v-card-title>
          <v-flex xs12 mt-3 mx-3>
            <v-card class="rounded">
              <v-card-text>
                <div
                  v-if="
                    ($store.getters.isOrgAdmin ||
                      $store.getters.isOrgOwner ||
                      $store.getters.isHRManager ||
                      $store.getters.isSuperAdmin) &&
                    !$store.getters.isCurrentOrgChild
                  "
                >
                  <v-stepper v-model="currentStep">
                    <v-stepper-header>
                      <v-stepper-step
                        color="#d13b55"
                        :complete="currentStep > 1 && amount > 0"
                        step="1"
                        >Enter Amount</v-stepper-step
                      >
                      <v-divider></v-divider>
                      <v-stepper-step
                        color="#d13b55"
                        :complete="
                          currentStep > 2 && createPaymentResponse != null
                        "
                        step="2"
                        >Payment Details</v-stepper-step
                      >
                      <v-divider></v-divider>
                      <v-stepper-step color="#d13b55" step="3"
                        >Order Complete</v-stepper-step
                      >
                    </v-stepper-header>
                    <v-stepper-items>
                      <v-stepper-content step="1">
                        <v-container fluid>
                          <v-layout row justify-center>
                            <v-flex xs12 md4>
                              <div class="px-2">
                                <v-radio-group v-model="buyOption" row>
                                  <v-radio
                                    label="Ovations"
                                    value="buyovations"
                                    color="#d13b55"
                                  ></v-radio>
                                  <v-radio
                                    label="Monthly Fee"
                                    value="monthlyfee"
                                    color="#d13b55"
                                  ></v-radio>
                                </v-radio-group>
                              </div>
                              <div class="d-flex">
                                <div
                                  style="flex-grow: 0 !important"
                                  class="mr-2 mt-2 title grey--text text--darken-1"
                                >
                                  $
                                </div>
                                <div>
                                  <v-text-field
                                    flat
                                    outline
                                    single-line
                                    type="number"
                                    :rules="amountRules"
                                    :min="1"
                                    label="Enter amount"
                                    v-model="amount"
                                    required
                                    hint="Enter amount"
                                    persistent-hint
                                  ></v-text-field>
                                </div>
                                <!-- <div class="ml-3 mr-2 font-weight-light title">
                                  +
                                </div>
                                <div>
                                  Transaction Fees:
                                  {{ getOnlinePaymentApiFees() }}% of ${{
                                    Number(amount).toFixed(2)
                                  }}
                                  = ${{ calculateFees() }}
                                </div> -->
                              </div>
                            </v-flex>
                          </v-layout>

                          <v-layout row mt-2 justify-center v-if="amount > 0">
                            <v-flex xs12 md4>
                              <div
                                class="mt-4 mb-4 text-xs-center"
                                v-if="buyOption === 'buyovations' && amount > 0"
                              >
                                <div class="subheading">You are buying</div>
                                <div
                                  class="my-2 d-inline-flex align-center display-1 text-main-theme font-weight-medium"
                                >
                                  <div class="mr-2">
                                    {{ calculateOvations() }} Ovations
                                  </div>
                                  <img
                                    width="32"
                                    src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-260-260.png"
                                    style="width: 32px"
                                  />
                                </div>
                                <div class="green--text">
                                  @
                                  <span class="font-weight-bold"
                                    >${{ orgConversionRate }}</span
                                  >
                                  per Ovation
                                  <!-- for ${{ getTotalAmount() }} -->
                                </div>
                              </div>
                              <div
                                class="mt-4 mb-4 text-xs-center"
                                v-if="buyOption === 'monthlyfee' && amount > 0"
                              >
                                <div class="mb-2 subheading">
                                  Paying monthly subscription fee for
                                </div>
                                <div class="d-flex">
                                  <v-flex>
                                    <v-select
                                      class="width-max-100px"
                                      dense
                                      outline
                                      single-line
                                      :items="monthList"
                                      v-model="selectedMonth"
                                      label="Month"
                                      hide-details
                                    ></v-select>
                                  </v-flex>
                                  <v-flex ml-2>
                                    <v-select
                                      class="width-max-100px"
                                      dense
                                      outline
                                      single-line
                                      :items="yearList"
                                      v-model="selectedYear"
                                      label="Year"
                                      hide-details
                                    ></v-select>
                                  </v-flex>
                                </div>
                              </div>
                              <div
                                class="text-xs-center"
                                style="margin-top: 44px"
                              >
                                <div
                                  class="d-flex"
                                  style="align-content: space-between"
                                >
                                  <div class="text-xs-left">Subtotal</div>
                                  <div class="text-xs-right">${{ amount }}</div>
                                </div>
                                <div
                                  class="d-flex my-2"
                                  style="
                                    align-content: space-between;
                                    border-top: 1px solid #ccc;
                                    border-bottom: 1px solid #ccc;
                                    padding: 8px 0;
                                  "
                                >
                                  <div class="text-xs-left">
                                    Transaction fees ({{
                                      getOnlinePaymentApiFees()
                                    }}%)
                                  </div>
                                  <div class="text-xs-right">
                                    ${{ calculateFees() }}
                                  </div>
                                </div>
                                <div
                                  class="d-flex subheading font-weight-bold"
                                  style="align-content: space-between"
                                >
                                  <div class="text-xs-left">Total</div>
                                  <div class="text-xs-right">
                                    ${{ getTotalAmount() }}
                                  </div>
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>

                          <v-layout row mt-4 justify-center>
                            <v-flex xs12 md3>
                              <div class="mt-4 text-xs-center">
                                <v-btn
                                  class="btn-rounded-medium white--text"
                                  color="#d13b55"
                                  @click="continueToPayment"
                                  :disabled="amount <= 0"
                                >
                                  Continue
                                </v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-stepper-content>
                      <v-stepper-content step="2">
                        <v-container fluid>
                          <v-flex v-if="loading">
                            <v-progress-linear
                              color="#d13b55"
                              height="2"
                              :indeterminate="true"
                            ></v-progress-linear>
                          </v-flex>

                          <!-- <v-layout row justify-center v-if="amount > 0">
                            <v-flex xs12 md6>
                              <div class="mt-4 text-xs-center title">
                                Buy
                                <span class="blue--text">{{
                                  calculateOvations()
                                }}</span>
                                Ovations for
                                <span class="orange--text"
                                  >${{ getTotalAmount() }}</span
                                >
                              </div>
                            </v-flex>
                          </v-layout> -->

                          <v-layout
                            row
                            justify-center
                            v-if="amount > 0 && !loading"
                          >
                            <v-flex xs12 md5>
                              <div class="text-xs-center caption mt-2">
                                <v-icon color="blue darken-2" size="16px"
                                  >mdi-pencil</v-icon
                                >
                                <a
                                  title="Change"
                                  href="#"
                                  @click.prevent="currentStep = 1"
                                  >Change</a
                                >
                              </div>
                            </v-flex>
                          </v-layout>

                          <v-layout row justify-center>
                            <v-flex xs12 md5>
                              <form id="payment-form">
                                <div id="card-container"></div>
                                <button
                                  v-if="amount > 0"
                                  type="button"
                                  @click.prevent="handlePaymentMethodSubmission"
                                  :disabled="loading"
                                >
                                  PAY ${{ getTotalAmount() }}
                                </button>
                              </form>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-stepper-content>
                      <v-stepper-content step="3">
                        <v-container fluid>
                          <v-layout
                            row
                            justify-center
                            v-if="createPaymentResponse"
                          >
                            <v-flex xs12 md6>
                              <div class="text-xs-center">
                                <div
                                  class="font-weight-medium headline blue--text"
                                >
                                  Order Completed
                                </div>
                                <div class="subheading mt-2">
                                  Your order has been completed with reference
                                  ID:
                                  <span class="body-2 font-weight-medium">{{
                                    createPaymentResponse.payment.referenceId
                                  }}</span>
                                </div>
                                <div
                                  class="caption mt-2"
                                  v-if="buyOption === 'buyovations'"
                                >
                                  Click finish to refresh Ovations.
                                </div>
                                <div class="mt-4">
                                  <v-btn
                                    class="btn-rounded-medium white--text"
                                    color="#d13b55"
                                    @click.prevent="finishOrder"
                                  >
                                    FINISH
                                  </v-btn>
                                </div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </div>
                <div v-else>
                  <v-alert :value="true" outline type="warning" icon="warning"
                    >Sorry! Either you do not have permission to view Or you
                    don't have any active org in your user profile Or you are in
                    a sub-org.</v-alert
                  >
                </div>
                <div
                  class="text-xs-center mt-2"
                  v-if="
                    ($store.getters.isOrgAdmin ||
                      $store.getters.isOrgOwner ||
                      $store.getters.isHRManager ||
                      $store.getters.isSuperAdmin) &&
                    !$store.getters.isCurrentOrgChild
                  "
                >
                  <span class="caption"
                    >Powered by
                    <v-icon size="18px">mdi-square-inc</v-icon>
                    <a
                      class="pl-1"
                      href="https://squareup.com/us/en"
                      title="https://squareup.com/us/en"
                      target="_blank"
                      >Square Inc.</a
                    ></span
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex></v-flex>
    <v-flex xs12 md3 px-3 mt-4 mr-2>
      <v-layout column wrap mt-4>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import validationRules from "@/js/validationRules.js";
import BalanceColumn from "@/components/BalanceColumn";

export default {
  name: "BuyOvations",
  components: { BalanceColumn },
  data() {
    return {
      loading: false,
      paymentCard: null,
      createPaymentResponse: null,
      currentStep: 0,
      amount: 0,
      totalAmount: 0,
      amountRules: validationRules.integerRules,
      buyOption: "buyovations",
      yearList: [
        (new Date().getFullYear() - 1).toString(),
        new Date().getFullYear().toString(),
      ],
      selectedYear: new Date().getFullYear().toString(),
      monthList: [
        { text: "Jan", value: "1" },
        { text: "Feb", value: "2" },
        { text: "Mar", value: "3" },
        { text: "Apr", value: "4" },
        { text: "May", value: "5" },
        { text: "Jun", value: "6" },
        { text: "Jul", value: "7" },
        { text: "Aug", value: "8" },
        { text: "Sep", value: "9" },
        { text: "Oct", value: "10" },
        { text: "Nov", value: "11" },
        { text: "Dec", value: "12" },
      ],
      selectedMonth: (new Date().getMonth() + 1).toString(),
    };
  },
  computed: {
    orgConversionRate: function () {
      return ((this.$store.state.userSelf.currentOrg || {}).org || {})
        .conversionRate;
    },
  },
  methods: {
    initializeCard: async function (payments) {
      const card = await payments.card({
        postalCode: this.$store.getters.getOrgZip,
      });
      await card.attach("#card-container");
      return card;
    },
    tokenize: async function (paymentMethod) {
      const tokenResult = await paymentMethod.tokenize();
      if (tokenResult.status === "OK") {
        return tokenResult.token;
      } else {
        let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
        if (tokenResult.errors) {
          errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
        }

        this.$store.commit("replaceSnackbar", {
          message:
            "Error: While getting payment card token.<br><strong>" +
            errorMessage +
            "</strong>",
          messageType: "error",
        });
      }
    },
    createPayment: function (token) {
      if (!token) {
        this.$store.commit("replaceSnackbar", {
          message: "Error: Please enter valid card details",
          messageType: "error",
        });
        this.loading = false;
        return;
      }

      this.loading = true;
      const params = {
        token,
        orgId: this.$store.getters.getOrgIdentifier,
        amount: Number(this.amount),
        totalAmount: parseFloat(this.getTotalAmount()),
        paymentCharge: parseFloat(this.calculateFees()),
        buyerEmail: this.$store.state.userSelf.profile.email,
        firstName: this.$store.state.userSelf.profile.firstname,
        lastName: this.$store.state.userSelf.profile.lastname,
        ovationsToBuy: Number(this.calculateOvations()),
        payMonthlyFee: this.buyOption === "monthlyfee",
        payMonth: this.buyOption === "monthlyfee" ? this.selectedMonth : "",
        payYear: this.buyOption === "monthlyfee" ? this.selectedYear : "",
      };

      axios
        .post("/api/org/ovations/buy", params, this.$store.state.axiosConfig)
        .then((res) => {
          this.loading = false;
          this.createPaymentResponse = res.data;
          this.$store.commit("replaceSnackbar", {
            message: `Payment successful. Reference Id: ${this.createPaymentResponse.payment.referenceId}`,
          });
          //this.resetPaymentForm();
          this.currentStep = 3;
        })
        .catch((err) => {
          this.loading = false;
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", err);

          // Display Error Message
          this.$store.commit("replaceSnackbar", {
            message:
              "Error in Payment Transaction.<br><strong>" +
              err.response.data.message +
              "</strong>",
            messageType: "error",
          });
        });
    },
    handlePaymentMethodSubmission: async function () {
      let that = this;
      if (!that.paymentCard) {
        that.$store.commit("replaceSnackbar", {
          message: "Error: Initializing Card failed",
          messageType: "error",
        });
        return;
      }

      if (Number(that.amount) <= 0) {
        that.$store.commit("replaceSnackbar", {
          message: "Please enter a valid amount",
          messageType: "warning",
        });
        return;
      }

      try {
        that.loading = true;
        const token = await that.tokenize(that.paymentCard);
        that.createPayment(token);
      } catch (e) {
        that.loading = false;
        that.$store.commit("replaceSnackbar", {
          message: "Error: While making payment request<br>" + e.message,
          messageType: "error",
        });
      }
    },
    resetPaymentForm: function () {
      this.paymentCard = null;
      this.amount = 0;
    },
    calculateOvations: function (amount) {
      return (
        Number(amount && amount > 0 ? amount : this.amount) /
        parseFloat(this.orgConversionRate)
      );
    },
    continueToPayment: function () {
      // Validate
      if (Number(this.amount) <= 0) {
        this.$store.commit("replaceSnackbar", {
          message: "Please enter a valid amount",
          messageType: "warning",
        });
        return;
      }

      this.currentStep = 2;
    },
    finishOrder: function () {
      this.resetPaymentForm();
      this.$router.push(
        { name: "dashboard" },
        function () {
          setTimeout(() => window.location.reload(), 500);
        },
        function () {}
      );
    },
    calculateFees: function () {
      return (
        Number(this.amount) *
        (this.getOnlinePaymentApiFees() / 100)
      ).toFixed(2);
    },
    getOnlinePaymentApiFees: function () {
      if (
        parseFloat(
          this.$store.state.userSelf.currentOrg.org.onlinePaymentApiFees
        ) > 0
      ) {
        return parseFloat(
          this.$store.state.userSelf.currentOrg.org.onlinePaymentApiFees
        );
      }
      return this.$store.state.onlinePaymentApiFees; // Return default value
    },
    getTotalAmount: function () {
      return (Number(this.amount) + parseFloat(this.calculateFees())).toFixed(
        2
      );
    },
  },
  watch: {},
  async mounted() {
    if (
      (this.$store.getters.isOrgAdmin ||
        this.$store.getters.isOrgOwner ||
        this.$store.getters.isHRManager ||
        this.$store.getters.isSuperAdmin) &&
      !this.$store.getters.isCurrentOrgChild
    ) {
      if (!window.Square) {
        this.$store.commit("replaceSnackbar", {
          message: "Error: Square.js failed to load properly",
          messageType: "error",
        });
      }

      const payments = window.Square.payments(
        this.$store.state.squareAppId,
        this.$store.state.squareLocationId
      );
      try {
        this.paymentCard = await this.initializeCard(payments);
      } catch (e) {
        this.paymentCard = null;
        this.$store.commit("replaceSnackbar", {
          message: "Error: Initializing Card failed",
          messageType: "error",
        });
      }
    }
  },
};
</script>

<style scoped>
#payment-form {
  max-width: 550px;
  /* min-width: 300px; */
  margin: 10px auto;
}

.buyer-inputs {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  border: none;
  margin: 0;
  padding: 0;
}

#card-container {
  margin-top: 45px;
  margin-bottom: 16px;
  /* this height depends on the size of the container element */
  /* We transition from a single row to double row at 485px */
  /* Settting this min-height minimizes the impact of the card form loading */
  min-height: 90px;
}

@media screen and (max-width: 500px) {
  #card-container {
    min-height: 140px;
  }
}

label {
  font-size: 12px;
  width: 100%;
}

input {
  padding: 12px;
  width: 100%;
  border-radius: 5px;
  border-width: 1px;
  margin-top: 20px;
  font-size: 16px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

input:focus {
  border: 1px solid #1976d2;
}

button {
  margin: 0 25%;
  color: #ffffff;
  background-color: #d13b55;
  border-radius: 6px;
  cursor: pointer;
  border-style: none;
  user-select: none;
  outline: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
  padding: 4px;
  width: 50%;
  box-shadow: 1px;
}

button:active {
  background-color: #d13b55;
}

button:disabled {
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.3);
}
</style>
